import React from 'react';
import PropTypes from 'prop-types';
import ModalBox from '../../../ui-core/Modal';

const Modal = props => {
  return (
    <ModalBox
      show={props.show}
      handleClose={props.handleClose}
      backdrop={'static'}
      bsPrefix={'onboarding-modal'}
      dialogClassName={props.dialogClassName}
      closeButton={props?.closeButton === false ? props?.closeButton : true}
      blurBackground={props.blurBackground || false}
    >
      {props.children}
    </ModalBox>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  dialogClassName: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  blurBackground: PropTypes.bool,
  closeButton: PropTypes.bool,
};

export default Modal;
